import 'babel-polyfill'
import Vue from 'vue'
import VueResource from 'vue-resource'
import domready from 'domready'
import VueShareBox from 'plugins/VueShareBox'
import VueAnalytics from 'vue-analytics'
import LoaderManager from 'components/LoaderManager'
import App from 'core/App.vue'
import Detector from 'utils/Detector'
import { router } from 'router'
window.loaderManager = new LoaderManager()
let isOld = Detector.isOld()

console.log('%c Codé avec 🌸 par %cUpian.com', 'background: #000; color: #fff; padding: 5px', 'font-weight:bold; background: #000; color: #fff; padding: 5px; padding-left:0')

domready(function () {
  if (isOld) {
    document.querySelector('.loader').style.display = 'none'
    document.querySelector('#outdated').style.display = 'block'

    return
  } else {
    WebFont.load({
      custom: {
        families: ['ChronicleTextG1-Roman', 'ChronicleTextG1-Italic', 'Lato-Light', 'Lato-Regular', 'Lato-Medium']
      },
      active: () => {
        init()
      }
    })
  }
})

function init () {
  const ids = [{
    id: 'UA-93069661-1'
  }, {
    id: 'UA-22971293-10',
    name: 'clientTracker'
  }]

  Vue.use(VueAnalytics, { ids, router })
  Vue.use(VueResource)
  Vue.use(VueShareBox)
  /* eslint-disable no-new */
  let app = new Vue({
    // store,
    router,
    render: h => h(App)
  }).$mount('#app')

  window.APP = {
    router: router
  }
}

// let app = new App({
//   container: document.querySelector('.app')
// })



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/